<h2 mat-dialog-title>
  {{ "SYSTEM_SETTINGS.TAB_USER.SESSION_EXPIRED_TITLE" | translate }}
</h2>
<mat-dialog-content>
  <div class="u-flex u-column u-gap-24">
    <span>{{
      "SYSTEM_SETTINGS.TAB_USER.SESSION_MSG"
        | translate: { seconds: (timer$ | async) }
    }}</span>
  </div>
</mat-dialog-content>
<br />
<mat-dialog-actions class="u-flex u-row u-jc-end u-ai-center">
  <button id="continue-button" (click)="continue()" mat-button color="accent">
    {{ "COMMON.CONTINUE" | translate }}
  </button>
</mat-dialog-actions>
